export default {
  gamePlay: {
    playTitle: 'All aboard the Puzzle Train!',
    playInstructions:
      '<p>Watch the puzzle pieces roll by and pull the lever when you see two pieces that fit together!</p>',
    playButton: "Let's ride!",
    instructions: {
      find: 'Watch for matching puzzle pieces!',
      findInOrder: 'Pull the lever when pieces fit together!',
      correct: 'Perfect match!',
      correctBonus: 'Excellent timing bonus!',
      incorrect: "Those pieces don't fit together!",
    },
  },
  rounds: {
    end: 'End of Round {{it.round}}',
    playNext: 'Play next round!',
    all: 'Excellent! You got {{it.correct}} trials correct!',
    some: 'Great job! You got {{it.correct}} trials correct in this round.',
    none: "Good try. Let's keep practicing!",
  },
  levelUp: {
    title: 'Amazing job, level up!!!',
    bodyRender: (level: number) =>
      `Moving to level ${level}, and you got some tickets!`,
  },
  gameComplete: {
    playTitle: 'Game Completed!',
    playInstructions:
      'Great work, you completed the game for the day. Keep practicing!',
    playButton: 'Return to games',
  },
  instructions: [
    {
      title: 'All Aboard!',
      body: 'The Puzzle Train is rolling into the station!<br>\nWatch as puzzle pieces come rolling by in each train car.',
      buttonText: 'Got it!',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/PuzzleTrain/audio/instructions-all-aboard-the-puzzle-t.mp3',
    },
    {
      title: 'Solve the puzzle!',
      body: 'You’ll only see one piece at a time. ',
      buttonText: 'Got it!',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/PuzzleTrain/audio/instructions-solve-the-puzzle-you-ll.mp3',
    },
    {
      title: 'Pull the Lever!',
      body: 'When you spot two pieces in a row that fit together to make a puzzle,<br>\nquickly PULL THE LEVER to stop the train and claim your reward!',
      buttonText: 'Got it!',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/PuzzleTrain/audio/instructions-pull-the-lever-when-you.mp3',
    },
    {
      title: 'Ready to ride?',
      body: 'As you level up, you’ll solve bigger puzzles. The train is about to depart! Ready to hop aboard?',
      buttonText: 'All aboard!',
      buttonText2: "Wait, let's go back!",
      buttonAction: 'goToPlay',
      buttonAction2: 'goToBeginning',
      audio:
        '/assets/games/PuzzleTrain/audio/instructions-ready-to-ride-as-you-le.mp3',
    },
  ],
};
